import components from './components/index.js';
import container from './container.js';

export default {
    components,
    container
};
